/**
 * Page Header Search
 *
 * Reads the URL template from data-search-url on the form,
 * substitutes {query}, {today}, and {end_next_year}, then navigates.
 * External searches (data-external) open in a new tab.
 */

function initPageHeaderSearch() {
  const form = document.querySelector('.page-header-search-form');
  if (!form) return;

  form.addEventListener('submit', (e) => {
    e.preventDefault();

    const input = form.querySelector('.page-header-search-input');
    const query = input.value.trim();
    if (!query) return;

    const today = new Date();
    const todayStr = today.toISOString().slice(0, 10);
    const endStr = `${today.getFullYear() + 1}-12-31`;

    const url = form.dataset.searchUrl
      .replace('{query}', encodeURIComponent(query))
      .replace('{today}', todayStr)
      .replace('{end_next_year}', endStr);

    if (form.hasAttribute('data-external')) {
      window.open(url, '_blank', 'noopener');
    } else {
      window.location.href = url;
    }
  });
}

document.addEventListener('DOMContentLoaded', initPageHeaderSearch);
